<template>
  <van-index-bar class="pwc-country-pane" :index-list="cIndex">
    <div v-for="(item, index) in cList" :key="index" class="pwc-country-item">
      <van-index-anchor v-if="item.anchor" :index="item.value" />
      <van-cell v-else :title="item.value" @click="handleSelect(item)">
        <van-icon
          v-if="item.selected"
          slot="right-icon"
          name="success"
          style="line-height: inherit; margin-right:36px;"
          color="#38f"
        />
      </van-cell>
    </div>
  </van-index-bar>
</template>

<script>
import CountryCodeInfo from './countrycode'
import Language from '@/constants/lang'
import { Icon, Cell, IndexAnchor, IndexBar } from 'vant'

export default {
  components: {
    VanIcon: Icon,
    VanCell: Cell,
    VanIndexAnchor: IndexAnchor,
    VanIndexBar: IndexBar
  },
  props: {
    current: {
      type: Number,
      default: 86
    }
  },
  data() {
    return {}
  },
  computed: {
    cIndex() {
      const s = new Set()
      const lang = this.$store.state.language

      CountryCodeInfo.forEach(e => {
        if (lang === Language.ZH) {
          s.add(e.index)
        } else {
          s.add(e.index_en)
        }
      })
      return Array.from(s).sort()
    },
    cList() {
      const list = []
      const indexMap = {}
      const lang = this.$store.state.language

      CountryCodeInfo.forEach((v) => {
        let index = ''
        if (lang === Language.ZH) {
          index = v.index
        } else {
          index = v.index_en
        }

        if (!indexMap[index]) {
          indexMap[index] = []
        }
        indexMap[index].push(Object.assign({}, v))
      })
      this.cIndex.forEach((e, i) => {
        if (i === 0 || i > 0 && this.cIndex[i] !== this.cIndex[i - 1]) {
          list.push({
            anchor: true,
            value: this.cIndex[i]
          })
        }

        list.push(...indexMap[e].map(v => {
          let name = ''
          if (lang === Language.ZH) {
            name = v.name
          } else {
            name = v.name_en
          }
          return {
            anchor: false,
            value: `${name} +${v.code}`,
            code: v.code,
            selected: false
          }
        }))
      })

      // top China
      const defaultTop = list.find(v => v.code === 86)
      if (defaultTop) {
        list.unshift(Object.assign({
        }, defaultTop))
      }

      // show success arrow when selected
      const current = list.find(v => v.code === this.current)
      if (current) {
        current.selected = true
      }

      return list
    }
  },
  methods: {
    handleSelect(country) {
      this.$emit('update:current', country.code)
      this.$emit('select', country)
    }
  }
}
</script>

<style lang="scss" scoped>
.pwc-country-pane {
  background-color: #f8f8f8;
}
</style>

<style lang="scss">
.pwc-country-pane {
  .van-index-bar__sidebar {
    width: 40px;

    .van-index-bar__index {
      line-height: 21px;
      color: #bbb;
    }
  }
  .pwc-country-item {
    .van-index-anchor {
      color: #999;
    }
    &:not(:last-child) .van-cell::after {
      position: absolute;
      box-sizing: border-box;
      content: ' ';
      pointer-events: none;
      right: 0;
      bottom: 0;
      left: 15px;
      border-bottom: 1px solid #ebedf0;
      transform: scaleY(.5)
    }
  }
}
</style>

